<template>
  <div class="home-container">
    <!-- 头部栏 -->
    <HomeHeader />
    <!-- 内容 -->
    <div class="container">
      <div class="name">集友科技创新（深圳）有限公司</div>
      <div class="description">
        <p>中国首家港资银行全资金融科技子公司，</p>
        <p>为厦门国际银行控股的集团成员之一，</p>
        <p>遵照集团统筹、高起点、独立性的战略部署，全力建设集团金融科技创新的窗口平台。</p>
      </div>
      <div class="ability-area">
        <div class="area" :style="{backgroundImage: `url(${contentImg1})`}" @click="e => openNewWin('introduction')">
          <span>公司简介</span>
          <div class="area-active">→</div>
        </div>
        <div class="area" :style="{backgroundImage: `url(${contentImg2})`}" @click="e => openNewWin('team')">
          <span>团队建设</span>
          <div class="area-active">→</div>
        </div>
        <div class="area" :style="{backgroundImage: `url(${contentImg3})`}" @click="e => openNewWin('history')">
          <span>公司历程</span>
          <div class="area-active">→</div>
        </div>
      </div>
    </div>
    <!-- 底部栏 -->
    <HomeFooter />
  </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue'
import HomeFooter from '@/components/HomeFooter.vue'

export default {
  name: 'index',
  components: { HomeHeader, HomeFooter },
  data () {
    return {
      contentImg1: require('@/assets/images/content1.png'),
      contentImg2: require('@/assets/images/content2.png'),
      contentImg3: require('@/assets/images/content3.png')
    }
  },
  mounted () {
    document.querySelectorAll('.ability-area .area').forEach((e, index) => {
      e.onmouseover = () => {
        let dom = document.querySelectorAll('.ability-area .area')[index].querySelector('.area-active')
        dom.setAttribute('style', 'display: flex;')
      }
      e.onmouseout = () => {
        let dom = document.querySelectorAll('.ability-area .area')[index].querySelector('.area-active')
        dom.setAttribute('style', 'display: none;')
      }
    })
  },
  methods: {
    openNewWin (url) {
      this.$router.push(`/${url}`)
    }
  }
}
</script>

<style scoped lang="less">
  .home-container {
    .container {
      .name {
        margin-top: 50px;
        margin-bottom: 30px;
        font-size: 28px;
        font-weight: bold;
        text-align: center;
        color: #333333;
      }
      .description p {
        margin: 10px 0;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        color: #666666;
      }
      .ability-area {
        margin: 50px auto;
        display: flex;
        justify-content: space-between;
        width: 1220px;
        .area {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 390px;
          height: 180px;
          background-size: cover;
          font-size: 20px;
          font-weight: bold;
          color: #FFFFFF;
          &::after {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            content: '';
            background-color: rgba(0, 0, 0, 0.3);
          }
          span {
            z-index: 1;
          }
          .area-active {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            content: '';
            background-color: rgba(240, 8, 220, 0.885);
            z-index: 1;
            display: none;
            align-items: center;
            justify-content: center;
            font-size: 60px;
            color: #FFFFFF;
          }
        }
      }
    }
  }
</style>